import queryString from 'query-string'
class SideMenuCls {
    constructor() {        
        this.menuObjList =[
             {path: "/summarydashboard", sidebarName: "Summary Dashboard", submenu:[], isLaunch: true, module:'Dashboard', accessModule:'Dispatcher', type:"I"},
            { path: "#", sidebarName: "Admin", className: "", icon: "fa fa-lock", type:"G",
              sub:[
                  {path: "/admin-dashboard", sidebarName: "Dashboard", submenu:[], isLaunch: true, type:"I", module:'Dashboard', accessModule:'Admin', baseURL:""},
                  {path: "/account", sidebarName: "Account", submenu:[], type:"I", module:'Account', baseURL:"/admin"},
                  {path: "/employees", sidebarName: "Employees", submenu:[], module:'Employee', type:"I", baseURL:"/admin"},                                                     
                  {path: "/trucks", sidebarName: "Trucks", submenu:[],  module:'Trucks', type:"I", baseURL:"/admin"},                      
                  {path: "/rateplan", sidebarName: "Default Rate Plan", submenu:[],  module:'Default Rate Plan', type:"I", baseURL:"/admin"},
                  {path: "/commission", sidebarName: "Commission", submenu:[],  module:'Commission', type:"I", baseURL:"/admin"},
                  {path: "/auction", sidebarName: "Auction", submenu:[],  module:'Auction', type:"I", baseURL:"/admin"},  
                  {path: "/vendors", sidebarName: "Vendors", submenu:[],  module:'Vendor', type:"I", baseURL:"/admin"},                
                  {path: "#", sidebarName: "Config",
                   submenu:
                   [
                       {path: "/towtype", sidebarName: "Tow Type",  module:'Tow Type', type:"I", baseURL:"/admin"},
                       {path: "/locations", sidebarName: "Locations Manager" ,module:'Location Manager', type:"I", baseURL:"/admin"},
                       {path: "/defaultRateplanChargeListDetails", sidebarName: "Custom Charges" ,module:'Custom Charges', type:"I", baseURL:"/admin"},
                       {path: "/apkUpdate", sidebarName: "APK Update" ,module:'APK Update', type:"I", baseURL:"/admin"},
                       {path: "/billingReportEmail", sidebarName: "Statement Email" ,module:'Statement Email', type:"I", baseURL:"/admin"},
                       {path: "/statementMessage", sidebarName: "Statement Message" ,module:'Statement Message', type:"I", baseURL:"/admin"},
                       {path: "/importExportRatePlans", sidebarName: "Import/Export Rate plans" ,module:'Import/Export Rate Plans', type:"I", baseURL:"/admin"}
                      /*  {path: "/billingterms", sidebarName: "Billing Terms",  module:'Billing Terms', type:"I", mainModule:"admin"}, */
                       
                    ], module:'Admin',subModule:'Config', type:"G"
                   }
                ],rootName:'admin',baseURL:'/admin', module:'Admin'
            },
            { path: "#", sidebarName: "Dispatcher", className: "", icon: "fa fa-user-circle-o", type:"G",
              sub:[                  
                  {path: "/dashboard", sidebarName: "Dispatcher Dashboard", submenu:[],  module:'Dispatcher Dashboard', type:"I", baseURL:"/dispatch"},
                  {path: "/addNewServiceCall", sidebarName: "Add New Service Call", submenu:[],  module:'Create New Call', type:"I", baseURL:"/dispatch"},
                  {path: "/invoiceSearch", sidebarName: "Invoice Details", submenu:[], checkEdit:true, module:'Dispatcher',subModule:'Invoice screen', type:"G", baseURL:"/dispatch"},
                //   {path: "/truckSummary", sidebarName: "Truck Details", submenu:[],  module:'Truck Details', type:"I", mainModule:"dispatch"},
                  {path: "/map", sidebarName: "Map", submenu:[],  module:'Map', type:"I", baseURL:"/dispatch"}        
                ],rootName:'dispatch',baseURL:'/dispatch',module:'Dispatcher'
            },	
            { path: "#", sidebarName: "Reports", className: "", icon: "fa fa-flag", type:"G",
              sub:[
                  {path: "/reports-dashboard", sidebarName: "Dashboard", submenu:[], isLaunch: true,  module:'Dashboard', type:"I", baseURL:"",accessModule:'Reports'},
                  {path: "/allInvoices", sidebarName: "All Invoice", submenu:[],  module:'All Invoices', type:"I", baseURL:"/reports"},        
                  {path: "#", sidebarName: "Accounting", type:"G",
                   submenu:
                   [
                       {path: "/ar-details", sidebarName: "A/R Detail",submenu:[],  module:'A/R Details', type:"I", baseURL:"/reports"},
                       {path: "/ar-detail-by-account-type", sidebarName: "A/R Detail by Account Type" ,submenu:[], module:'A/R Detail by Account Type', type:"I", baseURL:"/reports"},
                       {path: "/ar-summary", sidebarName: "A/R Summary" ,submenu:[], module:'A/R Summary', type:"I", baseURL:"/reports"},
                       {path: "/multiple-invoice-payment", sidebarName: "Batch Payments" ,submenu:[],  module:'Multiple Invoice Payment', type:"I", baseURL:"/reports"},
                       {path: "/payment-audit-report", sidebarName: "Payment Audit" ,submenu:[],  module:'Payment Audit Report', type:"I", baseURL:"/reports"},
                       {path: "/receipts", sidebarName: "Receipts" ,submenu:[],  module:'Receipts', type:"I", baseURL:"/reports"},
                       {path: "/billing", sidebarName: "Statements" ,submenu:[],  module:'Statements', type:"I", baseURL:"/reports"}
                    ], module:'Reports',subModule:'Accounting'
                   },
                   {path: "#", sidebarName: "Driver Management", type:"G",
                   submenu:
                   [
                       {path: "/driver-commission", sidebarName: "Driver Commissions Detail" ,submenu:[],  module:'Single Driver Commission', type:"I", baseURL:"/reports"},
                       {path: "/driver-commission-summary", sidebarName: "Driver Commissions Summary" ,submenu:[], module:'Driver Commission Summary', type:"I", baseURL:"/reports"},
                       {path: "/driver-performance-summary", sidebarName: "Driver Performance Summary" ,submenu:[],  module:'Driver Performance Summary', type:"I", baseURL:"/reports"},
                       {path: "/towlogs", sidebarName: "Driver Tow Logs" ,submenu:[],  module:'Driver Vehicle Inspection', type:"I", baseURL:"/reports"},
                       {path: "/employee-income", sidebarName: "Production by Truck Type" ,submenu:[],  module:'Production by Truck Type', type:"I", baseURL:"/reports"},
                    ], module:'Reports',subModule:'Driver Management'
                   },
                   {path: "#", sidebarName: "Storage Management", type:"G",
                   submenu:
                   [
                       {path: "/auction-list", sidebarName: "Auction List" ,submenu:[],  module:'Auction List', type:"I", baseURL:"/reports"},
                       {path: "/storage-inventory", sidebarName: "Storage Inventory" ,submenu:[],  module:'Storage Inventory', type:"I", baseURL:"/reports"},
                       {path: "/no-avr-filed", sidebarName: "No AVR Filed" ,submenu:[],  module:'No AVR Filed', type:"I", baseURL:"/reports"}
                    ], module:'Reports',subModule:'Storage Management'
                   },
                   {path: "#", sidebarName: "Account Management", type:"G",
                   submenu:
                   [
                    {path: "/account-contact-report", sidebarName: "Account Contact" ,submenu:[],  module:'Account Contact Report', type:"I", baseURL:"/reports"},
                    {path: "/activity-report", sidebarName: "Account Activity" ,submenu:[],  module:'Account Activity', type:"I", baseURL:"/reports"},
                    {path: "/ppi-revenue-report", sidebarName: "PPI Revenue" ,submenu:[],  module:'PPI Revenue Report', type:"I", baseURL:"/reports"}
                    ], module:'Reports',subModule:'Account Management'
                   },
                   {path: "#", sidebarName: "Invoice Management", type:"G",
                   submenu:
                   [
                    {path: "/missing-po-number", sidebarName: "Missing PO" ,submenu:[],  module:'Missing PO Number', type:"I", baseURL:"/reports"},
                    {path: "/negative-balance-report", sidebarName: "Negative Balance" ,submenu:[],  module:'Negative Balance Report', type:"I", baseURL:"/reports"},
                    {path: "/partial-payment-report", sidebarName: "Partial Payment" ,submenu:[],  module:'Partial Payment Report', type:"I", baseURL:"/reports"},
                    {path: "/unlocked-invoices", sidebarName: "Unlocked" ,submenu:[],  module:"Unlocked Report", type:"I", baseURL:"/reports"},
                    {path: "/unverified-invoices", sidebarName: "Unverified" ,submenu:[],  module:'Unverified invoices', type:"I", baseURL:"/reports"}
                    ], module:'Reports',subModule:'Invoice Management'
                   },
                   {path: "#", sidebarName: "Summaries", type:"G",
                   submenu:
                   [
                       {path: "/summary-by-account-rate-plan", sidebarName: "Summary by Account Rate Plan" ,submenu:[],  module:'Summary By Account Rate Plan', type:"I", baseURL:"/reports"},
                       {path: "/summary-by-driver", sidebarName: "Summary by Driver" ,submenu:[],  module:'Summary By Driver', type:"I", baseURL:"/reports"},
                       {path: "/summary-by-reason-code", sidebarName: "Summary by Reason" ,submenu:[],  module:'Summary By Reason Code', type:"I", baseURL:"/reports"},
                       {path: "/summary-by-tow-type", sidebarName: "Summary by Tow Type" ,submenu:[],  module:'Summary By Tow Type', type:"I", baseURL:"/reports"},
                       {path: "/summary-by-truck", sidebarName: "Summary by Truck" ,submenu:[],  module:'Summary By Truck', type:"I", baseURL:"/reports"},
                       {path: "/response-time-report", sidebarName: "Response Time" ,submenu:[],  module:'Response Time Report', type:"I", baseURL:"/reports"}
                    ], module:'Reports',subModule:'Summaries'
                   },
                   {path: "#", sidebarName: "Fleet Management", type:"G",
                   submenu:
                   [
                    {path: "/dvir", sidebarName: "Driver Vehicle Inspection" ,submenu:[],  module:'Driver Vehicle Inspection', type:"I", baseURL:"/reports"},
                   ], module:'Reports',subModule:'Fleet Management'},
                   {path: "#", sidebarName: "Custom", type:"G",
                   submenu:
                   [
                    {path: "/batch-invoice-payment", sidebarName: "Auction Batch Payment" ,submenu:[],  module:'Auction Batch Payment', type:"I", baseURL:"/reports"},
                    {path: "/custom-phoenix-pd-all-tows", sidebarName: "PHX All Tows" ,submenu:[],  module:'Custom: Phoenix PD All Tows', type:"I", baseURL:"/reports"},
                    {path: "/custom-phoenix-pd-release", sidebarName: "PHX Release" ,submenu:[],  module:'Custom: Phoenix PD Release', type:"I", baseURL:"/reports"},
                    ], module:'Reports',subModule:'Custom'
                   },
                  {path: "/customReports", sidebarName: "Report Builder", submenu:[], module:'Custom Report', type:"I", baseURL:"/reports"}  
                ],rootName:'reports',baseURL:'/reports', module:'Reports'
            },
            {path: "#", sidebarName: "In progress", className: "", icon: "fa fa-wrench", type:"G",
                   sub:
                   [
                    {path: "/account-report", sidebarName: "Contract Metrics" ,submenu:[],  module:'Contract Metrics', type:"I", baseURL:"/reports"},
                    {path: "/view-vcr-report", sidebarName: "View VCR" ,submenu:[],  module:'View VCR Report', type:"I", baseURL:"/reports"},
                    {path: "/owners-contact-info-by-contract", sidebarName: "Contact Info by Contract" ,submenu:[],  module:'Owner Contact Info by Contract', type:"I", baseURL:"/reports"},
                    {path: "/dispatch-clear-report", sidebarName: "Shift Report" ,submenu:[],  module:'Shift Report', type:"I", baseURL:"/reports"},
                    {path: "/company", sidebarName: "Company" ,module:'Company',submenu:[], type:"I", baseURL:"/admin"},
                    {path: "/truckSummary", sidebarName: "Truck Details", submenu:[],  module:'Truck Details', type:"I", baseURL:"/dispatch"}
                    ],rootName:'In progress',baseURL:'/reports', module:'In progress'
                   }
        ];
        this.redirectionMenuObj = [
            {
                path:'/summary-by-driver-details',
                selectedPath:'summary-by-account-rate-plan',
                pathParam:'byrateplan'
            },
            {
                path:'/summary-by-driver-details',
                selectedPath:'summary-by-reason-code',
                pathParam:'byreason'
            },
            {
                path:'/summary-by-driver-details',
                selectedPath:'summary-by-tow-type',
                pathParam:'bytowtype'
            },
            {
                path:'/summary-by-driver-details',
                selectedPath:'summary-by-truck',
                pathParam:'bytruck'
            },
            {
                path:'/summary-by-driver-details',
                selectedPath:'summary-by-driver',
                pathParam:'bydriver'
            },
            {
                path:'/accountDetails',
                selectedPath:'account',
                pathParam:''
            },
            {
                path:'/editServiceCall',
                selectedPath:'addNewServiceCall',
                pathParam:''
            },
            {
                path:'/accountDetails',
                selectedPath:'account',
                pathParam:''
            },
            {
                path:'/companyDetails',
                selectedPath:'company',
                pathParam:''
            },
            {
                path:'/vendorsDetails',
                selectedPath:'vendors',
                pathParam:''
            },
            {
                path:'/employeesDetails',
                selectedPath:'employees',
                pathParam:''
            },
            {
                path:'/commissionDetails',
                selectedPath:'commission',
                pathParam:''
            },
            {
                path:'/locationsDetails',
                selectedPath:'locations',
                pathParam:''
            },
            {
                path:'/trucksDetails',
                selectedPath:'trucks',
                pathParam:''
            },
            {
                path:'/defaultRateplanDetails',
                selectedPath:'rateplan',
                pathParam:''
            }
        ];
    }
    getMenuList=()=>{
       return this.menuObjList;
    }
    havingAccess=(module,accessLevels={},dashboardAccessLevels={})=>{
        let _accessModuleList=[];
        let _dashboardModuleList=[]; 
        Object.keys(accessLevels).map((_mainMod)=>{            
            Object.keys(accessLevels[_mainMod]).map((_subMod)=>{
                accessLevels[_mainMod][_subMod].map((_mod)=>{
                    _accessModuleList.push({group:_mainMod,subGroup:_subMod,..._mod})
                })
            });
        });
        _dashboardModuleList= Object.keys(dashboardAccessLevels).map((mainObj)=>{
           let viewAccess= dashboardAccessLevels[mainObj].some((item)=>{
                return (item.visible||false)===true;
            });
            if(mainObj==='Dispatcher'){
                viewAccess=true;
            }
            return {module:mainObj,access:viewAccess};
        });
        if(module.type==='G'){
            let filterList=_accessModuleList.filter((item)=>{
                if(module.subModule){
                    return item.group.toLowerCase()===module.module.toLowerCase() && item.subGroup.toLowerCase()===(module.subModule||'').toLowerCase()
                }else{
                    return item.group.toLowerCase()===module.module.toLowerCase() || item.subGroup.toLowerCase()===(module.subModule||'').toLowerCase()
                }                
            });
            let res= filterList.some(item=>{
                return ((item.basicAccess.view||false)===true||(item.basicAccess.add||false)===true||
                (item.basicAccess.edit||false)===true||(item.basicAccess.delete||false)===true);
            });
            if(!module.subModule){           
            const dashboardViewIdx=_dashboardModuleList.findIndex((item)=>{
                return item.module.toLowerCase()===module.module.toLowerCase();
            })
            if(dashboardViewIdx!==-1){
                if(!res){
                    res=_dashboardModuleList[dashboardViewIdx].access;
                }                
            }
        }
            return res;
        }
        if(module.type==='I'){
            if(module.isLaunch===true){
                const dashboardViewIdx=_dashboardModuleList.findIndex((item)=>{
                    return item.module.toLowerCase()===module.accessModule.toLowerCase();
                })
                if(dashboardViewIdx!==-1){
                    return _dashboardModuleList[dashboardViewIdx].access;
                }else{
                    return false;
                }
            }
            return (_accessModuleList.filter((item)=>{
                return (item.pageName===''?item.subGroup.toLowerCase():item.pageName.toLowerCase())===module.module.toLowerCase()
            }).some(item=>{
                return (item.basicAccess.view===true||item.basicAccess.add===true||
                item.basicAccess.edit===true||item.basicAccess.delete===true);
            }));
        }
        return false;
    }
    getSelectedMenuObj=(urlPath)=>{
        let _urlPath=urlPath.substr(1,urlPath.length);
        let pathObj={root:'',subRoot:'',child:''}
        let pathSplit=_urlPath.split('/');
        let pathName=pathSplit[1];
        if(_urlPath.trim()===''){
            pathObj.root='Dashboard';
            pathObj.subRoot= '';
            pathObj.child='summarydashboard'

        }else if(pathSplit.length===1){
            let _mainIndex=-1
            let _subIndex=-1;
            let _childIdx=-1;
            _mainIndex=this.menuObjList.findIndex(mainObj=>{
                if(mainObj.type==='I'){                    
                    return mainObj.path.toLowerCase()===('/'+pathSplit[0]).toLowerCase()
                }else{
                   if(mainObj.baseURL.toLowerCase()===('/'+pathSplit[0]).toLowerCase()){
                       return true;
                   } 
                    _subIndex= (mainObj.type==='I'?mainObj.submenu: mainObj.sub).findIndex((subObj=>{
                        if(subObj.path.toLowerCase()===('/'+pathSplit[0]).toLowerCase()){
                            return true;
                        }else{
                            _childIdx=subObj.submenu.findIndex(childObj=>{
                                return (childObj.path.toLowerCase()===('/'+pathSplit[0]).toLowerCase())?true:false
                            });
                            if(_childIdx==-1){
                                return false;
                            }else{
                                return true;
                            }
                        }
                    }));
                }                
                if(_subIndex!==-1){
                    return true;
                }
            })
            pathObj.root= this.menuObjList[_mainIndex].type==='I'?this.menuObjList[_mainIndex].module:this.menuObjList[_mainIndex].rootName;
            pathObj.subRoot= _subIndex===-1?'':this.menuObjList[_mainIndex].sub[_subIndex].module;
            pathObj.child=pathSplit[0]
        }else{
            pathObj.root=pathSplit[0]||"";
			let mainIndex=-1;
            mainIndex= this.menuObjList.findIndex(mainObj=>{                
                return (mainObj.rootName||'')===(pathSplit[0]||'')?true:false
            });
            const parsedHash = queryString.parse(window.location.search);
            this.redirectionMenuObj.findIndex(childObj=>{
                if(childObj.path.toLowerCase()===('/'+pathName).toLowerCase()){
                    if(childObj.pathParam === ''){
                        pathName=childObj.selectedPath;
                    }else{
                        if(childObj.pathParam === parsedHash.type){
                            pathName=childObj.selectedPath;
                        }
                    }
                }
            });
            let subIndex=-1
            if(mainIndex!==-1){
                let childIdx=-1;
                subIndex= this.menuObjList[mainIndex].sub.findIndex((subObj=>{
                if(subObj.path.toLowerCase()===('/'+pathName).toLowerCase()){
                    return true;
                }else{  
                        childIdx=subObj.submenu.findIndex(childObj=>{
                            return (childObj.path.toLowerCase()===('/'+pathName).toLowerCase())?true:false
                        });
                        if(childIdx===-1){
                            return false;
                        }else{
                            return true;
                        }
                }
            }));
            }
            if(subIndex!==-1){
                pathObj.subRoot=this.menuObjList[mainIndex].sub[subIndex].module;
            }else{
                pathObj.subRoot=''
            }
            pathObj.child=pathName||"";
        }        
        return pathObj
    }
    haveAccess=(mainModule,subModule=undefined,accessLevels={})=>{
        let haveAccess=false;
        let accessGroup= accessLevels;
        if(!subModule){
            if(Object.keys(accessGroup).length>0){
                haveAccess=Object.keys(accessGroup[mainModule]).some((item)=>{
                    let itemAccess=false;
                    itemAccess= (accessGroup[mainModule][item]).some((subItem)=>{
                        return subItem.basicAccess.add===true||subItem.basicAccess.edit===true||subItem.basicAccess.view===true
                    })
                    return itemAccess;
                });                   
            }
        }
        else{
            /* if(Object.keys(accessGroup).length>0){
                let Idx=Object.keys(accessGroup[mainModule]).findIndex((mod)=>{
                    return (mod.toLowerCase()===subModule.toLowerCase())
                })
                if(Idx!==-1){
                    haveAccess=Object.keys(accessGroup[mainModule])[Idx].permissionView===1?true:false
                    if(!haveAccess){
                       let selectedMod= this.getMenuList().find((option)=>{
                            return option.module===mainModule;
                        });
                        if(selectedMod){
                          let subOption=  selectedMod.sub.find(item=>{
                               return item.module===subModule
                            });
                            if((subOption||{}).checkEdit===true){
                                haveAccess=accessGroup[mainModule][Idx].permissionUpdate===1?true:false
                            }
                        }else{
                            haveAccess=false;
                        }
                    }
                }
            } */
    
        }
        return haveAccess=true;
    }
   
}
export default SideMenuCls
